module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/100-pakistan-e071e258176979a466a5cdd967c97525.svg";